module.exports = "https://tutorchat.chegg.com/static/media/ic-shape-line.0b6a4948.svg";